export function throttle<T extends unknown[], U>(
  func: (...args: T) => U,
  limit: number
): (...args: T) => void {
  let lastFunc: ReturnType<typeof setTimeout>;
  let lastRan: number;

  return (...args: T) => {
    if (!lastRan) {
      func(...args); // Call the function immediately
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(
        () => {
          if (Date.now() - lastRan >= limit) {
            func(...args); // Call the function after the delay
            lastRan = Date.now();
          }
        },
        limit - (Date.now() - lastRan)
      );
    }
  };
}
